<div class="row row-gap-3">
  <div class="col-12 col-lg-6" *ngFor="let method of deliveryMethods">
    <mat-card>
      <mat-card-header>
        <div
          class="header-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxFlex="100"
        >
          <mat-toolbar>
            <div class="d-flex justify-content-between w-100">
              <div class="title d-flex align-items-center" mat-card-title>
                <jam-icon [name]="method.icon" />
                {{ method.name }}
              </div>
              <div class="card-action">
                <jam-icon name="pen" color="accent" mat-ripple (click)="editDeliveryMethod(method)" />
                <jam-icon name="trash" color="warn" mat-ripple (click)="deleteDeliveryMethod(method)" />
              </div>
            </div>
          </mat-toolbar>
        </div>
      </mat-card-header>
      <mat-card-content>
        <div class="card-data container my-3">
          <div class="label">توضیح</div>
          <div>{{ method.desc }}</div>
          <div class="label">حداقل خرید برای ارسال رایگان</div>
          <div>
            {{
              method.minPurchaseForFreeShipping
                ? (method.minPurchaseForFreeShipping | number : "1.") + " تومان"
                : "-"
            }}
          </div>
          <div class="label">هزینه ارسال</div>
          <div>
            {{
              +method.valueAdded > 0
                ? (method.valueAdded | number : "1.") + " تومان"
                : "رایگان"
            }}
          </div>
          <div class="label">شهرها</div>
          <div *ngIf="method.cities && method.cities.length <= 10">
            <span *ngFor="let city of method.cities; let index = index"
              >{{ city.name
              }}<span *ngIf="index < method.cities.length - 1">، </span></span
            >
          </div>
          <div *ngIf="method.cities && method.cities.length >= 50">
            {{
              method.cities && method.cities.length >= 50
                ? "همه شهرهای ایران"
                : ""
            }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-12 col-lg-6">
    <mat-card class="add-card" (click)="addNewDeliveryMethod()">
      <div class="plus-sign-oncard">
        +
      </div>
    </mat-card>
  </div>
</div>
